import { Button, SpacerWrapper } from '@ahmdigital/ui';
import styled from 'styled-components';

export const StyledWrapper = styled(SpacerWrapper)`
  color: ${({ theme }) => theme.colors.white};
  max-width: 35.625rem;
  margin: -0.5rem -1rem;
  text-align: left;

  @media (min-width: ${({ theme }) => theme.media.sm}) {
    margin-left: -0.5rem;
    margin-right: -0.5rem;
  }

  @media (min-width: ${({ theme }) => theme.media.md}) {
    margin: -1rem -1rem -0.5rem 15rem;
  }
`;

export const DisclaimerWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 1.5rem;

  @media (min-width: ${({ theme }) => theme.media.md}) {
    flex-direction: row;
    align-items: center;
  }
`;

export const StyledButton = styled(Button)`
  margin: 0.75rem 0 0.5rem 0;
  text-wrap: nowrap;

  @media (min-width: ${({ theme }) => theme.media.md}) {
    margin: 0 0 0 1rem;
  }
`;
